import { useState } from 'react';
import UI from '../ui';
import { useNavigate } from 'react-router';
import useUserState from '../states/useUserState';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { setUserId } = useUserState();
  return (
    <UI.VerticalLayout height="100%" justify="end" gap={60} align="center" width="100%">
      <img
        style={{ maxWidth: '120px' }}
        alt="logo"
        src="./assets/logo_black.svg"
      />
      <UI.VerticalLayout gap={20} width="100%">
        <UI.VerticalLayout align="start">
          <UI.Text weight="bold" size="title">
            Join Zylo and see where your friends have been to!
          </UI.Text>
          {/* <UI.Text>
            Lorem ipsum dolor sit amet
          </UI.Text> */}
        </UI.VerticalLayout>
        <UI.VerticalLayout gap={5}>
          <UI.Textfield label="Username" value={username} onChange={setUsername} placeHolder="Enter username" />
          <UI.Textfield label="Password" value={password} onChange={setPassword} placeHolder="Enter password" type="password" />
          <UI.Text align="right"><UI.TextLink path="/forgot-password">Forgot your password?</UI.TextLink></UI.Text>
          <UI.Button
            label="Log in"
            onClick={() => {
              setUserId('4'); // 4 is "Sarah Alali's" id. If there's time, mock creating a new user
              navigate('/home');
            }}
          />
        </UI.VerticalLayout>
        <UI.Divider label="or log in with" />
        <div style={{ paddingRight: '30px', paddingLeft: '30px' }}>
          <UI.HorizontalLayout justify="space-between">
            <UI.SocialButton type="google" onClick={() => {}} />
            <UI.SocialButton type="facebook" onClick={() => {}} />
            <UI.SocialButton type="instagram" onClick={() => {}} />
            <UI.SocialButton type="apple" onClick={() => {}} />
          </UI.HorizontalLayout>
        </div>
      </UI.VerticalLayout>
      <UI.Text align="center">
        Don't have an account?
        &nbsp;
        <UI.TextLink path="/register">Register</UI.TextLink>
      </UI.Text>
    </UI.VerticalLayout>
  );
};

export default LoginPage;
